<template>
    <div class="contact">
        <modal class="contact-success" :display="modalStatus.contactSuccess" @modalStatus="closeModal()" >
            <img class="alarm-img" src="@/assets/img/landingPage/contact/success_blue.svg" alt="">
            <h1>很高興收到您的訊息，將盡快聯絡您。</h1>
            <div class="btn-group">
                <button class="default-button" @click="$router.push('/')">回首頁</button>
            </div>
        </modal>

        <div class="contact-wrap">
            <div class="page-title">洽談合作</div>
            <div class="input-block-wrap">
                <div class="input-block">
                    <div class="left">
                        <div class="input-wrap">
                            <label>
                                <span>*</span>
                                <span>姓名/公司名稱</span>
                            </label>
                            <input :class="{error: error.contact.name}" type="text" v-model="contact.name" placeholder="請輸入姓名/公司名稱"/>
                        </div>
                        <div class="input-wrap">
                            <label>
                                <span>*</span>
                                <span>手機號碼</span>
                            </label>
                            <input :class="{error: error.contact.cellphone}" type="text" v-model="contact.cellphone" placeholder="請輸入手機號碼"/>
                        </div>
                        <div class="input-wrap">
                            <label>
                                <span>*</span>
                                <span>Email信箱</span>
                            </label>
                            <input :class="{error: error.contact.email}" type="text" v-model="contact.email" placeholder="請輸入Email信箱"/>
                        </div>
                    </div>
                    <div class="right">
                        <div class="textarea-wrap">
                            <label>
                                <span>*</span>
                                <span>合作內容</span>
                            </label>
                            <textarea :class="{error: error.contact.content}" v-model="contact.content" placeholder="請填寫合作內容"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btn-block">
                <button @click="storeContactData">送出</button>
            </div>
        </div>
    </div>
</template>

<script>
import Modal from '@/components/widge/Modal.vue';

export default {
    mounted () {
        this.$analytics.logEvent("洽談合作", {
            screen_name: "洽談合作"
        });
    },
    components: {
        Modal
    },
    data () {
        return {
            contact: {
                name: null,
                cellphone: null,
                email: null,
                content: null,
            },
            error: {
                contact: {
                    name: null,
                    cellphone: null,
                    email: null,
                    content: null,
                }
            },
            modalStatus:{
                contactSuccess: false
            },
        }
    },
    methods: {
        storeContactData: function () {
            if(this.checkInput()){
                var $this = this;
                this.$firebaseStore.collection("contact")
                .add(this.contact)
                .then(function(docRef) {
                    console.log("success");
                    // console.log("Document written with ID: ", docRef.id);
                    // 成功
                    $this.openModal();
                })
                .catch(function(error) {
                    console.log("error");
                    // console.error("Error adding document: ", error);
                    // 失敗
                });
            }
        },
        checkInput: function () {
            if(!this.contact.name){
                this.error.contact.name = '請輸入姓名/公司名稱'
            }else{
                this.error.contact.name = null
            }
            if(!this.contact.cellphone){
                this.error.contact.cellphone = '請輸入手機號碼'
            }else{
                this.error.contact.cellphone = null
            }
            if(!this.contact.email){
                this.error.contact.email = '請輸入Email信箱'
            }else{
                this.error.contact.email = null
            }
            if(!this.contact.content){
                this.error.contact.content = '請輸入合作內容'
            }else{
                this.error.contact.content = null
            }
            if(this.contact.name &&
                this.contact.cellphone &&
                this.contact.email &&
                this.contact.content &&
                this.error.contact.name == null &&
                this.error.contact.cellphone == null &&
                this.error.contact.email == null &&
                this.error.contact.content == null
            ){
                return true
            }else{
                return false
            }
        },
        openModal: function () {
            this.$store.commit('modalStatus/set_modal_mode', true)
            this.modalStatus.contactSuccess = true
        },
        // closeModal: function () {
        //     this.$store.commit('modalStatus/set_modal_mode', false)
        //     this.modalStatus.contactSuccess = false
        // },
    }
}
</script>

<style lang="scss">
.contact {
    #modal {
        .modal-content {
            .detail {
                padding: 56px 50px 40px 50px;
            }
            .cancle {
                display: none;
            }
            h1 {
                font-size: 22px;
                font-weight: normal;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #292625;
                margin-top: 44px;
                margin-bottom: 68px;
            }
            .btn-group {
                width: 100%;
                button {
                    width: 100%;
                }
            }
        }
    }
    .contact-wrap {
        margin-top: 36px;

        .page-title {
            font-size: 32px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.34;
            letter-spacing: 1.92px;
            color: #3b302c;
            text-align: center;
        }
        .input-block-wrap {
            display: flex;
            justify-content: center;

            .input-block {
                display: flex;
                margin-top: 36px;
                margin-bottom: 20px;

                .left,
                .right {
                    width:325px;
                }
                .left {
                    margin-right: 36px;
                }
                .input-wrap {
                    margin-bottom: 30px;
                    text-align: left;
                }
                .input-wrap, .textarea-wrap {
                    label {
                        display: block;
                        margin-bottom: 7px;
                        span { 
                            font-size: 16px;
                            font-weight: 500;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: normal;
                            letter-spacing: normal;
                            color: #28292d;
                        }
                        span:nth-child(1) {
                            font-size: 18px;
                            font-weight: normal;
                            font-stretch: normal;
                            font-style: normal;
                            line-height: 1;
                            letter-spacing: normal;
                            color: #fc7171;
                            position: relative;
                            top: 3px;
                        }
                    }
                    input, 
                    textarea {
                        width: 100%;
                        padding: 12px 16px;
                        border-radius: 8px;
                        border: solid 2px #d7d7d7;
                        background-color: #fff;
                        height: unset;
                        box-sizing: border-box;
                    }
                    input:hover, 
                    textarea:hover,
                    input:focus, 
                    textarea:focus {
                        border: solid 2px #353535;
                    }
                    textarea {
                        resize: none;
                        height: 266px;
                    }
                    input.error,
                    textarea.error {
                        border: solid 2px #ff6868;
                    }
                }
            }
        }   
        .btn-block {
            text-align: center;

            button {
                box-sizing: border-box;
                width: 347px;
                padding: 12px;
                text-align: center;
                border-radius: 8px;
                background-color: #fb9479;
                font-size: 16px;
                font-weight: 500;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #ffffff;
                cursor: pointer;
            }
        }
    }
}
@media screen and (max-width: 1100px){
    .contact {
        #modal {
            .modal-content {
                margin-left: 25px;
                margin-right: 25px;
            }
        }
        .contact-wrap {
            .input-block-wrap {
                .input-block {
                    display: block;
                    width: 100%;
                    padding: 0 20px;
                    .left {
                        margin-right: 0px;
                    }
                    .left, .right {
                        width: unset;
                    }
                }
            }
            .btn-block {
                padding: 0 20px;
                button {
                    width: 100%;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/officailPage/contact/contact.vue